<template>
    <div>
        <div class="basic-info row">
            <div class="col col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <ul class="list-style-none">
                    <li class="mt-1">
                        <b>Contact Name:</b>
                        {{userDetail.firstName}} {{userDetail.lastName}}
                    </li>
                    <li class="mt-0">
                        <b>User Locked:&nbsp;</b>
                        <span v-if="userDetail.isLocked">
                            <font-awesome-icon :icon="['far','check-square']" />&nbsp;&nbsp;
                            <a href="javascript:void(0)" @click="openUnlockModel()" :disabled="$store.getters.isImpersonation">Unlock User</a>
                        </span>
                        <span v-if="!userDetail.isLocked">
                            <font-awesome-icon :icon="['far','square']" />
                        </span>
                    </li>
                </ul>
            </div>
            <div class="col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-end">
                <ul class="list-style-none">
                    <li class="mt-1">
                        <b>Global User Status:&nbsp;</b>
                        <font-awesome-icon class="icon-pointer"
                                           :icon="isEnabled == true? 'toggle-on':'toggle-off'"
                                           :class="isEnabled == true? 'svg-green me-1 ms-1' : 'svg-red me-1 ms-1'"
                                           :title="isEnabled == true? 'Enabled':'Disabled'"
                                           v-on:click="openToggelUserStatusModel()" />
                        <span v-if="isEnabled == true">Enabled</span>
                        <span v-else>Disabled</span>
                    </li>
                    <li class="mt-1">
                        <a class="btn slim-button"
                           target="_blank"
                           :href="manageUserNotificationUrl">Manage User Notifications</a>
                    </li>
                    <li class="mt-2">
                        <span v-if="isEnabled === true">
                            <a class="btn slim-button"
                               href="javascript:void(0)"
                               v-on:click="openResetPasswordModel()">Reset Password</a>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <UserUnlock :username="userDetail.userName"
                    :userDetail="userDetail"
                    @onUserUnlock="onUserUnlockSuccess"></UserUnlock>
        <ResetPassword :userDetail="userDetail"></ResetPassword>
        <UserDisableError ref="userDisableErrorRef" :message="message" :headerMessage="headerMessage"></UserDisableError>
        <ToggleUserStatus :userDetail="userDetail"
                          :message="message"
                          :headerMessage="headerMessage"
                          :StatusButtonTxt="StatusButtonTxt"
                          :isValid="isValid"
                          @statusChanged="onStatusChanged" ref="toggelStatusModal"></ToggleUserStatus>
        <loading v-model:active="isLoading" :can-cancel="true"></loading>
        <InfoPopup :popupmessage="info.message" :title="info.title" ref="InfoModel"></InfoPopup>
    </div>
</template>

<script>
    import UserUnlock from "./UserUnlock";
    //import axios from 'axios';
    import { Component as Loading } from "vue-loading-overlay";
    import ResetPassword from "./ResetPassword";
    import ToggleUserStatus from "./ToggleUserStatus";
    import UserDisableError from "./UserDisableError";
    import { eventbus } from "../../main";
    import InfoPopup from "./InfoPopup";
    import enviromentVariable from '../../constants/enviromentVariable';
    export default {
        name: "BasicInformation",
        components: {
            UserUnlock,
            ResetPassword,
            ToggleUserStatus,
            UserDisableError,
            Loading,
            InfoPopup
        },
        data() {
            return {
                headerMessage: "",
                StatusButtonTxt: "",
                message: "",
                currentUserAccountDetail: null,
                loggedInUserDetail: this.$store.getters.adminAccounts,
                isValid: false,
                isLoading: false,
                isDone: false,
                timer: "",
                isEnabled: this.userDetail.enabled,
                manageUserNotificationUrl: enviromentVariable.manageUserNotificationUrl,
                info: {
                    message: "",
                    title: ""
                },
            };
        },
        props: {
            userDetail: {},
            userAccounts: {},
            canDisable: Boolean,
            isEnable: Boolean
        },
        watch: {
            // Keep local isEnabled in sync when userDetail is (re)populated after mount.
            userDetail: {
                handler(newVal) {
                    if (newVal) this.isEnabled = newVal.enabled;
                },
                deep: true
            }
        },
        mounted() {
            var that = this;
            eventbus.on("statusChanged", function (isEnabled) {
                that.isEnabled = isEnabled;
                that.$emit("UserStatusChanged", isEnabled);
            });
        },
        methods: {
            openUnlockModel: function () {
                if (!this.$store.getters.isImpersonation) {
                    this.$bvModal.show("unlockUser");
                }
                else {
                    this.info.title = "Information Message";
                    this.info.message = "This action is not allowed while impersonating";
                    this.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }
            },
            onStatusChanged(value) {
                this.isEnabled = value;
                this.$emit("UserStatusChanged", this.isEnabled);
            },
            onUserUnlockSuccess: function (isSuccess) {
                this.userDetail.isLocked = !isSuccess;
            },
            openResetPasswordModel: function () {
                if (!this.$store.getters.isImpersonation) {
                    this.$bvModal.show("ResetPassword");
                }
                else {
                    this.info.title = "Information Message";
                    this.info.message = "This action is not allowed while impersonating";
                    this.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }
            },
            openToggelUserStatusModel: function () {
                if (!this.$store.getters.isImpersonation) {
                    if (this.canDisable == true) {
                        this.message =
                            "Disabling a user will disable ALL access for ALL accounts and applications to which this user is associated. The user will be unable to log into the Support Site or Salesforce Community for this account and any others they are associated to, including accounts you may not have admin access to. Additionally, their Salesforce contacts will be deactivated for ALL corresponding accounts. If you wish to disable a user's access to this specific account, please use the Remove From Account option in the Account and Application Access tab for this user.";
                    } else {
                        this.message =
                            "You do not have the required permission to disable this user. This user is associated to other accounts you may not have access to.Please contact your account representative or 24/7 Technical Support:";
                    }
                    if (this.isEnabled) {
                        this.headerMessage = "Disable User";
                        this.StatusButtonTxt = "Disable";
                        if (this.canDisable) {
                            this.$refs.toggelStatusModal.$refs["toggleUserStatusModal"].show();
                        } else {
                            if (this.$refs.userDisableErrorRef && this.$refs.userDisableErrorRef.$refs["UserDisableErrorModal"])
                                this.$refs.userDisableErrorRef.$refs["UserDisableErrorModal"].show();
                            else
                                this.$bvModal.show("UserDisableError");
                        }
                    } else {
                        this.headerMessage = "Enabled User";
                        this.StatusButtonTxt = "Enabled";
                        this.message =
                            "Enabling a user will give the user access to all accounts that this user is associated to, including accounts you may not have admin access to.";
                        this.$refs.toggelStatusModal.$refs["toggleUserStatusModal"].show();
                    }
                }
                else {
                    this.info.title = "Information Message";
                    this.info.message = "This action is not allowed while impersonating";
                    this.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }
            }
        }
    };
</script>

<style>
    ul.basic-info {
        list-style: none;
        padding: 0;
    }

    .pull-right {
        float: right;
    }

    .nav-tabs .nav-link {
        border: 0;
    }

        .nav-tabs .nav-item.show .nav-link,
        .nav-tabs .nav-link.active {
            color: #007bff;
        }

    .nav-tabs .nav-item.show .nav-link,
    .nav-tabs .nav-link {
        color: #495057;
    }
</style>